import { render } from "./PpcSbBudgetAllocationItem.vue?vue&type=template&id=7424ee07&scoped=true"
import script from "./PpcSbBudgetAllocationItem.vue?vue&type=script&lang=js"
export * from "./PpcSbBudgetAllocationItem.vue?vue&type=script&lang=js"

import "./PpcSbBudgetAllocationItem.vue?vue&type=style&index=0&id=7424ee07&lang=scss&scoped=true"
import "./PpcSbBudgetAllocationItem.vue?vue&type=style&index=1&id=7424ee07&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7424ee07"]])

export default __exports__